import MarkdownContentRenderer from 'fitify-ui-landing/src/components/Markdown/MarkdownContentRenderer'

import content from '../../../../public/assets/markdown/terms.md'

export const Terms = () => {
  return <MarkdownContentRenderer content={content} />
}
